import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './socialMatchesPanels.module.scss'
import classNames from 'classnames'
import SocialMatchesContainer from '../SocialMatchesContainer'
import { MatchUpSubmissionStateEnum } from 'types/api/enums'
import { Paging, Player } from 'types/global'
import { useDispatch } from 'react-redux'
import { getApprovedMatchesForPlayer } from 'actions/social-matches-actions'
import NoScoresPanel from './NoScoresPanel'
import Panel from 'components/generic/containers/Panels'

interface Props {
  player?: Player
}

const ScoresPanel = ({ player }: Props) => {
  const { t: tSocialMatches } = useTranslation('strSocialMatches')
  const dispatch = useDispatch()
  const fetch = useCallback(
    ({ skip, limit }: Paging) => {
      if (player) dispatch(getApprovedMatchesForPlayer(player.id, { skip, limit }))
    },
    [dispatch, player]
  )

  if (!player) return null

  return (
    <Panel className={classNames(styles.panel)} hasShadow fullWidthAtTablet as='section'>
      <h2 className={styles.title}>{tSocialMatches('myScores.titleOther')}</h2>
      <SocialMatchesContainer
        type={MatchUpSubmissionStateEnum.APPROVED}
        fetch={fetch}
        stateMappingKey={player.id}
        renderIfNoMatches={
          <NoScoresPanel
            title={tSocialMatches('myScores.noScoresPanel.otherPlayer.title', {
              firstName: player.firstName,
            })}
            info={tSocialMatches('myScores.noScoresPanel.otherPlayer.info', {
              firstName: player.firstName,
            })}
            className={styles.noScorePanel}
          />
        }
      />
    </Panel>
  )
}

export default ScoresPanel
